export default __webpack_public_path__ + "static/media/magnifying_glass.1840f13f.svg";